import axios from "axios";
import { getConfig } from '../helpers/config';

export class PagamentoService {

  baseAPIUrl = `${getConfig()?.url}pagamenti`;

  getAllDt = async (data) => {
    return await axios.post(`${this.baseAPIUrl}/allDt`, data).then(resp => resp.data);
  }

  valida = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(`${this.baseAPIUrl}/valida`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Errore durante l'invio del file CSV:", error);
      throw error;
    }
  };

  importa = async (file) => {
      try {
        const formData = new FormData();
        formData.append("file", file);
  
        const response = await axios.post(
          `${this.baseAPIUrl}/importa`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        return response.data;
      } catch (error) {
        console.error("Errore durante l'importazione del file CSV:", error);
        throw error;
      }
    };

    getUltimaImportazione = async () => {
      return await axios.get(`${this.baseAPIUrl}/latest`)
    }
}